// extracted by mini-css-extract-plugin
export var button = "ConsentModal-module--button--92a04";
export var description = "ConsentModal-module--description--6c88b";
export var fadeInAnimation = "ConsentModal-module--fadeInAnimation--81c9d";